// Plays the race search page's tour (ViewComponents::Tours::EventSearch), whose
// steps ride on the "Tour this page" button and point inside the filters and
// results that packs/event_search_setup.js mounts, so nothing here happens until
// it fires event-search:mounted.
//
// The page is public, so this browser remembers that it has played: it starts
// by itself on the first visit only (through utilities/page_prompts.js), and the
// button replays it.
import { startTour } from '../utilities/guided_tour';
import { offerPagePrompt, PRIORITY } from '../utilities/page_prompts';

const SEEN_KEY = 'event_search_tour_seen';

// Deferred like every pack, so the page is parsed and the button is there, but
// the search pack mounts on DOMContentLoaded, after this has run.
const button = document.getElementById('event-search-tour');

if (button) {
  const config = JSON.parse(button.dataset.config);
  const play = () => {
    localStorage.setItem(SEEN_KEY, 'true');
    startTour(config);
  };
  const mounted = new Promise((resolve) => {
    document.addEventListener('event-search:mounted', () => {
      button.addEventListener('click', play);
      resolve();
    }, { once: true });
  });

  if (localStorage.getItem(SEEN_KEY) !== 'true') {
    offerPagePrompt({ priority: PRIORITY.tour, ready: mounted, play });
  }
}
